import { ModalV3 } from '@jouzen/ecom-components';

import type { LandingPageHeroChicletModalDialogProps } from '@/app/components/LandingPage/LandingPageHero/LandingPageHeroChiclet/LandingPageHeroChicletModal';
import Video from '@/app/components/Video/Video';

const GiveUsTheFingerVideoModal = ({
  isOpen,
  onToggle,
}: LandingPageHeroChicletModalDialogProps) => {
  return (
    <ModalV3
      isOpen={isOpen}
      onOpenChange={onToggle}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gutf-video-wrapper">
          <Video
            className="size-full"
            contentTitle="gutf_campaign_video"
            location="gutf-hero"
            playVideo={isOpen}
            preload="metadata"
            type="video/mp4"
            posterSrc="gutf-campaign/Brand_FY25_30s_Web_16x9_FullFrame-GUTF-compressed-video-poster.png"
            src="gutf-campaign/Brand_FY25_30s_Web_16x9_FullFrame-GUTF-compressed.mp4"
          />
        </div>
      </div>
    </ModalV3>
  );
};

export default GiveUsTheFingerVideoModal;
